// TODO enable eslint
/* eslint-disable react/destructuring-assignment */
import React from "react"
import cn from "classnames"
import styles from "./styles"

export default BaseComponent => props => (
  <BaseComponent
    {...props}
    className={cn(styles.FullHeight, props.className)}
  />
)
